export default "__VITE_ASSET__8c799ded__"